module.exports = __webpack_public_path__ + "static/media/shopify.d606e30a.png";